import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION_BY_ID = 'REMOVE_NOTIFICATION_BY_ID';
export const REMOVE_NOTIFICATION_BY_TYPE = 'REMOVE_NOTIFICATION_BY_TYPE';

export interface StoredNotification {
    type: string;
    props: Record<string, unknown>;
    uniqueType: boolean;
    id: number;
}

interface PayloadTypes {
    [ADD_NOTIFICATION]: StoredNotification;
    [REMOVE_NOTIFICATION_BY_ID]: number;
    [REMOVE_NOTIFICATION_BY_TYPE]: string | string[];
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const addNotificationAction = ActionCreator(ADD_NOTIFICATION);
export const removeNotificationByIdAction = ActionCreator(REMOVE_NOTIFICATION_BY_ID);
export const removeNotificationByTypeAction = ActionCreator(REMOVE_NOTIFICATION_BY_TYPE);

export const INITIAL_STATE = [];

export default createReducer<StoredNotification[], PayloadTypes>(INITIAL_STATE, {
    [ADD_NOTIFICATION]: (state, action) => [action.payload, ...state],
    [REMOVE_NOTIFICATION_BY_ID]: (state, action) => state.filter((notification) => notification.id !== action.payload),
    [REMOVE_NOTIFICATION_BY_TYPE]: (state, action) => {
        const notificationTypes = typeof action.payload === 'string' ? [action.payload] : action.payload;
        return state.filter((notification) => !notificationTypes.includes(notification.type));
    },
});
